import React, { useState } from 'react';

interface ShortResponseResultsDisplayProps {
    questionText?: string;
    responses: string[];
}

const ShortResponseResultsDisplay: React.FC<ShortResponseResultsDisplayProps> = ({ questionText, responses }) => {

    const [visibleCount, setVisibleCount] = useState(10);

    const displayedResponses = responses.slice(0, visibleCount);

    const handleShowMore = () => {
        setVisibleCount(prevCount => prevCount + 10);
    };

    const handleShowLess = () => {
        setVisibleCount(10);
    };

    const handleShowAll = () => {
        setVisibleCount(responses.length);
    };

    return (
        <div className="flex flex-col w-full gap-4">
            <div className="flex justify-between items-center">
                <h3 className="text-lg md:text-2xl text-[#3da8e2]">{questionText}</h3>
                <button
                    onClick={handleShowAll}
                    className="text-blue-500 hover:underline"
                >
                    Show All
                </button>
            </div>
            <div className="flex flex-col gap-2">
                {displayedResponses.map((response, index) => (
                    <div key={index} className="flex items-center gap-2">
                        <span>{index + 1}</span>
                        <label>{response}</label>
                    </div>
                ))}
            </div>
            {responses.length > visibleCount && (
                <button
                    onClick={handleShowMore}
                    className="mt-2 text-blue-500 hover:underline"
                >
                    Show More
                </button>
            )}
            {visibleCount > 10 && (
                <button
                    onClick={handleShowLess}
                    className="mt-2 text-blue-500 hover:underline"
                >
                    Show Less
                </button>
            )}
        </div>
    );
};

export default ShortResponseResultsDisplay;